//const { anime } = require('materialize-css');

//jQuery plaugin
window.$ = window.jQuery = require('jquery');

//window.Popper = require('popper.js').default;
//require('./bootstrap');
//require('./materialize.min.js');
//require('~materialize-css/dist/js/materialize.js');


//GSAP animation plugin
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

//without this line, PixiPlugin and MotionPathPlugin may get dropped by your bundler (tree shaking)...
gsap.registerPlugin(ScrollTrigger);


//lottie player plugin
import "@lottiefiles/lottie-player";




/*
document.addEventListener('DOMContentLoaded', function() {
    initHome();
});*/



/*window.$ = window.jQuery = require('jquery');



//pjax transitions
var {PjaxTransition} = require('./PjaxTransition');
*/


//pjax transitions
//var {Tester} = require('./Tester');


//main init after page load
$(function() {
	
	$("body").addClass("onload");
	$("[title]").removeAttr("title");
	//window.setTimeout(function(){
	//}, 3000);
	
	//detect touch devices
	$("body").one("touchstart", function(e){
		$("body").addClass("touchdevice");
	});
    
    //all actions on page contact
    const pageHome = new PageHome();
    
    //all animations (header)
    const globalAnimations = new GlobalAnimations();
    
    //all modals (imprint contact form)
    const modals = new Modals();
    
    
    //all global events
    const eventListener = new EventListener();
    

});














//-- classes




class PageHome {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);
        this.pageRefresh();
    }
    
    //call on page changes
    pageRefresh() {
        this.initCoverParallax();
        this.initSocialParallax();
        this.initSlideshowList();
        this.initSlideLoop();
        this.initSlideNav();
        this.initRegisterWithName();
        
    }

    
    
    //init register with name buttons
    initRegisterWithName(){
		let $btns = $("[data-register-with-name]");
		if(!$btns.length) return;
		//add register button click handler
		$btns.on("click", function(e){
			let $input = $($(this).attr("data-register-with-name"));
			if(!$input.length) return true;
			let name = $input.val();
			if(!name) return true;
			e.preventDefault();
			let url = $(this).attr("href");
			url += "?name="+name;
			window.location.href = url;
		});
	}

    
    //init slides with auto loop
    initSlideLoop(){
		let $navGroups = $("[data-slideloop]");
		if(!$navGroups.length) return;
		let SPEED = 5000; //scroll speed by card in seconds
		let cardGap = 15;

		//resort all invisible items to the end of the list
		let resort = function($group){
			let $list = $group.find(".s-list");
			if(!$list.length) return;
			let $card = findNextCard($group);
			let cardX = $card.position().left;
			let scrollX = $list[0].scrollLeft;
			let index = $card.index();
			for (let i = 0; i < index-1; i++) {
				let $item = $list.find(">li").first().remove();
				$list.append($item);
				scrollX -= ($item.width() + cardGap);
			}
			$list[0].scrollLeft = scrollX;
		};

		/* //resort all invisible items to the end of the list
		let resort = function($group){
			let $list = $group.find(".s-list");
			if(!$list.length) return;
			let $card = $list.find(">li").first().remove();
			$list.append($card);
			//let toX = currX + (cardW * dir);
			//$list[0].scrollLeft = toX;
		}; */

		//find the next visible card
		let findNextCard = function($group){
			let $list = $group.find(".s-list");
			if(!$list.length) return;
			let $card = null;
			$list.find(">li").each(function(i){
				let $item = $(this);
				if($card) return;
				if($item.position().left <= cardGap) return;
				$card = $item;
			});
			return $card;
		};
		
		

		//add scroll button click handler
		let scrollhandler = function($group){
			let $list = $group.find(".s-list");
			if(!$list.length) return;
			if($list.hasClass("scrollStop")) return;

			//resort($group);
			//return;
//
			//let $card = findNextCard($group);
			//console.log('found: '+$card.index());
			//return;
			//let $card = $list.find(">li:eq(1)");

			resort($group);

//TODO: find first visible card
			let $card = findNextCard($group);
			let cardW = $card.width()+cardGap;
			//let currX = $list[0].scrollLeft;
			//let toX = currX + (cardW * dir);
			let toX = cardW;
			let scrollLeft = $list[0].scrollLeft;
			let scrollSpeed = SPEED / cardW * (cardW-scrollLeft);
			
			$list.addClass("autoscroll");

			$list.animate({
				scrollLeft: toX
			}, scrollSpeed, 'linear',
				function(){
					// complete
					//resort($group);
					//$list[0].scrollLeft = 0;
					/*$list.find(">li.active").removeClass("active");
					let activeIndex = Math.floor($(window).width()/cardW/2);
					let $activeCard = $list.find(">li").eq(activeIndex);
					$activeCard.addClass("active");
					window.setTimeout(function(){
						$activeCard.removeClass("active");
					}, 1500);*/
					$list.removeClass("autoscroll");
					scrollhandler($group);
				}
			);
		
		};
		
		//add scroll listener to enable/disable buttons
		$navGroups.each(function(){
			let $group = $(this);
			scrollhandler($group);

			/*window.setInterval(function(){
			//window.setTimeout(function(){
				scrollhandler($group);
			}, 2000);*/
		});

		//add scroll stop handler
		let restartTO;
		$navGroups.on("mouseover touchstart", function(e){
			window.clearTimeout(restartTO);
			//$(this).addClass("scrollStop");
			$(this).find(".s-list").stop();
			$(this).find(".s-list").addClass("scrollStop");
			$(this).find(".s-list").removeClass("autoscroll");
		});
		//$navGroups.on("mouseout", function(e){
		$navGroups.on("mouseleave", function(e){
			let $group = $(this);
			$group.find(".s-list").removeClass("scrollStop");
			scrollhandler($group);
		});
		$navGroups.on("touchend", function(e){
			let $group = $(this);
			//$group.find(".s-list").removeClass("scrollStop");
			//scrollhandler($group);

			// let $group = $(e.currentTarget);
			window.setTimeout(function(){
				$group.find("li:focus")[0].blur();
				$group.find("li.active").removeClass("active");
			}, 1500); 
			window.clearTimeout(restartTO);
			restartTO = window.setTimeout(function(){
				$group.find(".s-list").removeClass("scrollStop");
				scrollhandler($group);
			}, 2000); 
		});
		
		/* $navGroups.find(".s-list").on("scroll", function(e){
			let $list = $(e.currentTarget);
			if($list.hasClass("autoscroll")){
				console.log('auto scrolling');
				
			}else{
				$(this).addClass("scrollStop");

				console.log('scrolling');
			}
		}); */

	}
    
	
    //init slides with auto loop
    /* initSlideLoop_old(){
		let $navGroups = $("[data-slideloop]");
		if(!$navGroups.length) return;

		//add scroll button click handler
		let resort = function($group){
			let $list = $group.find(".s-list");
			if(!$list.length) return;
			let $card = $list.find(">li").first().remove();
			$list.append($card);
			//let toX = currX + (cardW * dir);
			//$list[0].scrollLeft = toX;
		};

		//add scroll button click handler
		let scrollhandler = function($group){
			let dir = 1;
			let $list = $group.find(".s-list");
			if(!$list.length) return;
			//if($group.hasClass("scrollStop")) return;
			if($list.hasClass("scrollStop")) return;
			let $card = $list.find(">li:eq(1)");
			let cardW = $card.width()+15;
			let currX = $list[0].scrollLeft;
			//let toX = currX + (cardW * dir);
			let toX = cardW * dir;

			$list.addClass("autoscroll");

			$list.animate({
				scrollLeft: toX
			}, 2000, 'swing',
				function(){
					// complete
					resort($group);
					$list[0].scrollLeft = 0;
					$list.find(">li.active").removeClass("active");
					let activeIndex = Math.floor($(window).width()/cardW/2);
					let $activeCard = $list.find(">li").eq(activeIndex);
					$activeCard.addClass("active");
					window.setTimeout(function(){
						$activeCard.removeClass("active");
					}, 1500);
					$list.removeClass("autoscroll");
				}
			);
		
		};
		
		//add scroll listener to enable/disable buttons
		$navGroups.each(function(){
			let $group = $(this);
			
			window.setInterval(function(){
			//window.setTimeout(function(){
				scrollhandler($group);
			}, 4500);
		});

		//add scroll stop handler
		$navGroups.on("mouseover touchstart", function(e){
			//$(this).addClass("scrollStop");
			$(this).find(".s-list").stop();
			$(this).find(".s-list").addClass("scrollStop");
			$(this).find(".s-list").removeClass("autoscroll");
		});
		$navGroups.on("mouseout", function(e){
			//$(this).removeClass("scrollStop");
			$(this).find(".s-list").removeClass("scrollStop");
		});
		$navGroups.on("touchend", function(e){
			let $group = $(e.currentTarget);
			window.setTimeout(function(){
				$group.find(".s-list").removeClass("scrollStop");
			}, 4500);
		});

	} */
    
	
    
    //init slide navigation buttons
    initSlideNav(){
		let $navGroups = $("[data-slidenav]");
		if(!$navGroups.length) return;

		//add scroll button click handler
		$navGroups.find(".m-slidenav").on("click", "button", function(e){
			let dir = ($(this).index()==0) ? -1 : 1;
			let $group = $(this).closest("[data-slidenav]");
			let $list = $group.find(".s-list");
			let $nav = $group.find(".m-slidenav");
			if(!$list.length) return;
			if(!$nav.length) return;
			let cardW = $list.find(">li").first().width();
			let currX = $list[0].scrollLeft;
			$list[0].scrollLeft = currX + (cardW * dir);
		});
		
		//enable/disable buttons
		let scrollhandler = function($group){
			let $list = $group.find(".s-list");
			let currX = $list[0].scrollLeft;
			let scrollWidth = $list[0].scrollWidth;
			let windowW = window.innerWidth;
			let $btnLeft = $group.find(".m-slidenav button:first-child");
			let $btnRight = $group.find(".m-slidenav button:last-child");

			//enable/disable buttons
			$btnLeft.prop("disabled", (currX<=0));
			$btnRight.prop("disabled", (currX>=(scrollWidth-windowW)));
		};

		//add scroll listener to enable/disable buttons
		$navGroups.each(function(){
			let $group = $(this);
			let $list = $group.find(".s-list");
			
			$list[0].addEventListener('scroll', () => {
				scrollhandler($group);
			}, { passive: true });

			scrollhandler($group);
		});

		//window resize => refresh buttons
		window.addEventListener('resize', () => {
			$navGroups.each(function(){
				let $group = $(this);
				scrollhandler($group);
			});
		}, { passive: true });

	}
    
	
    
    //slideshow with fadeings from a list
    initSlideshowList(){
		let $lists = $("[data-slideshow]");
		if(!$lists.length) return;

		$lists.each(function(){
			let $list = $(this);
			let delay = $list.attr("data-slideshow");
			window.setInterval(function(){
				let maxIndex = $list.find(">li").length;
				let activeIndex = $list.attr("data-active");
				if(!activeIndex) activeIndex = 0;
				activeIndex++;
				if(activeIndex>maxIndex) activeIndex = 1;
				$list.attr("data-active", activeIndex);
			}, delay);
		});
	}
    
    //cover phone scroll animation
    initCoverParallax(){
		
		if(!$("#homePhonecircleBg").length) return;

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: "#homePhonecircleBg",
				start: "bottom 100%",
				end: "top top",
				scrub: true,
				markers: 0
			}
		})
		.fromTo("#homePhonecircleBg .s-phonecircle-bg-inner", {height: "0%"}, {height: "100%"});
 
		/*
		
	    ScrollTrigger.matchMedia({
			
			// mobile
			"(max-width: 1023px)": function() {
                let tl = gsap.timeline({
					scrollTrigger: {
						trigger: "#homePhonecircleBg",
						start: "bottom 70%",
						end: "top top",
						scrub: true,
						markers: 1
					}
				})
				.fromTo("#homePhonecircleBg .s-phonecircle-bg-inner", {height: "0%"}, {height: "100%"});
            },
			
			// desktop
			"(min-width: 1024px)": function() {
                let tl = gsap.timeline({
					scrollTrigger: {
						trigger: "#homePhonecircleBg",
						start: "bottom bottom",
						end: "top top",
						scrub: true,
						markers: 1
					}
				})
				.fromTo("#homePhonecircleBg .s-phonecircle-bg-inner", {height: "0%"}, {height: "100%"});
		
            }
        });
        */
	}
    
    
    initSocialParallax(){
        if( !$(".parallax").length ) return;

	    ScrollTrigger.matchMedia({
			
			// mobile
			"(max-width: 1023px)": function() {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".parallax",
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        markers: 0

                    }
                });

                gsap.utils.toArray(".parallax [data-parallax_m]").forEach(layer => {
                    const depth = layer.dataset.parallax_m;
                    const height = 100; //layer.offsetHeight
                    const movement = -(height * depth)
                    tl.to(layer, {y: movement, ease: "none"}, 0)
                });
            },
			
			// desktop
			"(min-width: 1024px)": function() {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".parallax",
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        markers: 0

                    }
                });

                gsap.utils.toArray(".parallax [data-parallax_d]").forEach(layer => {
                    const depth = layer.dataset.parallax_d;
                    const height = 100; //layer.offsetHeight
                    const movement = -(height * depth)
                    tl.to(layer, {y: movement, ease: "none"}, 0)
                });
            }
        });
        
        
    }

		
}



class EventListener {
	constructor() {
        this.initButtons();
    }
    
	   
    initButtons(){
		
		//detect touch devices
		/* $("body").one("touchstart", function(e){
			$("body").addClass("touchdevice");
		}); */
		
		
		
		//lan nav
		/* $(".lannav").on("click", "a", function(e){
			e.preventDefault();
			$(this).closest("nav").find(".active").removeClass("active");
			$(this).addClass("active");
			
			var deeplink = $("body").attr("data-deeplink");
			window.location.href = $(this).attr("href")+"/"+deeplink;
			
		}); */
		
		
		//scrollto 
	    /* $("body").on("click", "[data-scroll]", function(e){
		    e.preventDefault();
			const target = $(this).attr("data-scroll");	   
			$("body,html").animate({
				scrollTop: $(target).offset().top
			}, 800);
		   
	    }); */
	    
	    
	    //close menu on click
	    $(".header").on("click", "a", function(e){
			$("#sliderToggle").prop("checked", false);
			$("body").removeClass("noscroll");
			$(this).addClass("active");
	    });
	    
	    //toggle main menu
	    $(".header").on("change", "#sliderToggle", function(e){
			const enabled = $(this).is(":checked");
			$("body").toggleClass("noscroll", enabled);
	    });


		//form submit
		$("form button[data-submit]").on("click", function(e){
			//$(this).closest('form')[0].submit();
			var form = $(this).closest('form')[0];
			if (form.checkValidity()) { // true, wenn alle required/valid
				form.submit();
			} else {
				form.reportValidity(); // zeigt die native Validierungs-Hinweise
			}

		});
	    
	    
	}
}
      


/*
class EventListener {
	constructor() {
        this.initButtons();
    }
    
	   
    initButtons(){
		
		//detect touch devices
		$("body").one("touchstart", function(e){
			$("body").addClass("touchdevice");
		});
		
		
		
		//lan nav
		$(".lannav").on("click", "a", function(e){
			e.preventDefault();
			$(this).closest("nav").find(".active").removeClass("active");
			$(this).addClass("active");
			
			var deeplink = $("body").attr("data-deeplink");
			window.location.href = $(this).attr("href")+"/"+deeplink;
			
		});
		
		
		//scrollto 
	    $("body").on("click", "[data-scroll]", function(e){
		    e.preventDefault();
			const target = $(this).attr("data-scroll");	   
			$("body,html").animate({
				scrollTop: $(target).offset().top
			}, 800);
		   
	    });
	    
	    
	    //close menu on click
	    $("body").on("click", ".mainNav a", function(e){
			$("#navToggle").prop("checked", false);
			$("body").removeClass("noscroll");
			
			if(!$(this).is("[data-nopjax]")){
				$(this).addClass("active");
			}
			
	    });
	    
	    //toggle main menu
	    $("body").on("change", ".mainNav #navToggle", function(e){
			const enabled = $(this).is(":checked");
			$("body").toggleClass("noscroll", enabled);
	    });
	    
	    
	}
}
      
   
      

      
     
     
      
class PageContact {
	constructor() {
        this.pageRefresh();
    }
    
    //call on page changes
    pageRefresh() {

		//check for page contact
		if( $("body").attr("data-template") != "contact" ){ 
			return;
		}
        this.initForm();
    }
    
    
    initForm(){
	    const $form = $("#contactForm"); 
		if(!$form.length) return; 

	    const $feedback = $form.find("#feedback"); 

		const that = this;
		
		$form.on("submit", function(e){
			e.preventDefault();
			
			$feedback.removeClass("error").html("");
			if(!that.validateForm($form)){ 
				$feedback.addClass("error").html( $feedback.attr("data-feedback-invalid") ); //"Bitte Eingabe prüfen"
				return false;
			}
			$feedback.html("Bitte warten...");
			that.sendForm($form, function(){
				$feedback.html( $feedback.attr("data-feedback-ok") ); //"Vielen Dank"
				$form[0].reset();
				$form[0].reset();
				
			}, function(){
				$feedback.addClass("error").html( $feedback.attr("data-feedback-error") ); //"Leider ist ein Fehler aufgetreten"
			});
		});
		
    }  
    
    sendForm($form, onSuccess, onError){
		var url = $form.attr("data-action");
		var data = $form.serialize();
		$.post(url, data, function(data) { 
			if(data && data.success){
				onSuccess();
			}else{
				onError();
			}
		}, "json");
	}
	    
    validateForm($form){
		$form.addClass("validated");
	    
	    if( !$form.find("#name").val() ){
		    this.scrollToError("name");
		    return false;
	    }
	    if( !this.validateEmail($form.find("#email").val()) ){
		    this.scrollToError("email");
		    return false;
	    }
	    if( !$form.find("#privacy").is(":checked") ){
		    this.scrollToError("privacy");
		    return false;
	    }
		$form.removeClass("validated");
	    return true;
    }   
    
    validateEmail(email){
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }
    

    
    scrollToError(id){
		const $target = $("#"+id);	   
		$("body,html").animate({
			scrollTop: $target.offset().top - 200
		}, 500);
	}
}     
     
*/



class GlobalAnimations {
	constructor() {
		//gsap.registerPlugin(ScrollTrigger);
        this.pageRefresh();
    }
    
    //call on page changes
    pageRefresh() {
        this.initHeader();
        this.initLottie();
        this.initProgressbar();
    }
    
    //progressbar scroll animation
    initProgressbar(){
		if(!$(".progressbar").length) return;

		let tl = gsap.timeline({
			scrollTrigger: {
				start: 0,
				scrub: true,
				markers: 0
			}
		})
		.fromTo(".progressbar .s-progress", {width: "100%"}, {width: "0%"});
	}
    
    //@docs: https://github.com/LottieFiles/lottie-player
    initLottie(){
		$("[data-lottie-action='hover']").on("mouseover", function(){
			const $l = $(this).find("lottie-player");
			if($l.length){ 
				$l[0].seek(0);
				$l[0].setDirection(1);
				$l[0].play();
			}
		});

		/*$("[data-lottie-action='hover']").on("mouseout", function(){
			const $l = $(this).find("lottie-player");
			if($l.length){ 
				//$l[0].setSpeed(2);
				$l[0].setDirection(-1);
				$l[0].play();
			}
		});*/
	}



    initHeader(){
		
		//shrink header on scroll
		/* ScrollTrigger.create( {
			trigger: "main",
			start: "-20 top",
			markers: 0,
			toggleClass: {targets: "#header", className: "small"},
		}); */
		
		//shrink header on scroll
		ScrollTrigger.create( {
			trigger: "#headerTrigger",
			start: "bottom top",
			markers: 0,
			onEnter: function({progress, direction, isActive}){
				$("#header").addClass("small");
			}, 
			onEnterBack: function({progress, direction, isActive}){
				$("#header").removeClass("small");
			} 
		});
		
		//hide header on scroll to bottom
		ScrollTrigger.create( {
			trigger: ".footer",
			start: "top bottom",
			markers: 0,
			toggleClass: {targets: "#header.small", className: "hide"},
						
		});

		/*
		//shrinkt header on scroll
	    ScrollTrigger.matchMedia({
			
			// desktop
			"(min-width: 768px)": function() {
				$("#header").removeClass("small");

				//scroll direction
				ScrollTrigger.create( {
					trigger: "main",
					start: "-20 top",
					markers: 0,
					toggleClass: {targets: "#header", className: "small"},
								
				});
			}
			
		});*/
	}


		
}


class Modals {
	constructor() {
        this.initModals();
    }
    
    initModals(){
		var that = this;
	    
	    //close modals on click background
	    $("body").on("click", ".modal.open", function(e){
		    if(!$(e.target).hasClass('modal')) return;
			const $modal = $(this);
			that.closeModal($modal);
	    });
	    
	    //close modals on click close
	    $("body").on("click", ".modal.open .modal-close", function(e){
			const $modal = $(this).closest(".modal");
			that.closeModal($modal);
	    });
	    
	    //close modals on trigger close event
	    $("body").on("close", ".modal.open", function(e){
			const $modal = $(this);
			that.closeModal($modal);
	    });
	    
	    //open modals on click
	    $("body").on("click", "[data-modal]", function(e){
		    e.preventDefault();
		    const $modal = $("#"+$(this).attr("data-modal"));
		    const modalLoadPath = $(this).attr("data-modal-load");
		    if(modalLoadPath){
				//that.loadModalContent($modal, modalLoadPath);
		    }else{
				that.openModal($modal);
			}
	    });
	    
	}
	
    /*loadModalContent($modal, path){
	    const $modalContent = $modal.find(".modal-content");
		$modal.addClass("open");
	    $modalContent.load(path, function(){
			$modal.addClass("fade");
		    
	    });
	}*/
	
    openModal($modal){
		$("body").addClass("noscroll");
		$modal.addClass("open");
		$modal.scrollTop(0);
		window.setTimeout(function(){
			$modal.addClass("fade");			
		}, 30);
	}
	
	
    closeModal($modal){
		$("body").removeClass("noscroll");
		$modal.removeClass("fade");
		window.setTimeout(function(){
			$modal.removeClass("open");
		}, 500);
    
	}
	   
}





class PjaxTransition{
	
	constructor(containerId, transitionSpeed, pageRefreshCallback) {
        this.pjaxContainer = containerId || '#pjax-container';
        this.pjaxTransitionSpeed = transitionSpeed || 300
        this.pageRefreshCallback = pageRefreshCallback;
        this.init();
    }
    
    //private
	init() {
        const that = this;

        $(document).on("pjax:timeout", function(e) {
            //Link jump event due to block timeout
            e.preventDefault();
            console.log("pjax.timeout");
        });

        
        var pjaxLink = "";
        var pjaxTransitionSpeed = this.pjaxTransitionSpeed; //300;
        var pjaxContainer = this.pjaxContainer; //'#pjax-container';
        var pjaxTO = null;

        $(document) .pjax('a:not([data-nopjax]):not([target="_blank"])', pjaxContainer)
            .on('pjax:click', function(e){                
                //save pjaxLink
                pjaxLink = $(e.target).attr("href");
				//console.log("PJAX:click: "+pjaxLink);
                
                $(e.target).css("pointer-events", "none");
                
                //avoid double clicks
                window.setTimeout(function(){
                    $(e.target).css("pointer-events", "");
                }, pjaxTransitionSpeed);
                

            })
            .on('pjax:beforeSend', function(e,o){
                var isPageTransition = $("body").attr("data-pjax-transition");
                //$("body").attr("data-pjax-transition", isPageTransition?"":"1");
                $("body").attr("data-pjax-transition", "1");
                
                if(!isPageTransition && pjaxLink){ 
                    that.transitionStart();
                    window.clearTimeout(pjaxTO);
                    pjaxTO = window.setTimeout(function(){
                        $.pjax({url: pjaxLink, container: pjaxContainer});
                        pjaxLink = "";
						$("body").attr("data-pjax-transition", "");
                    }, pjaxTransitionSpeed);
                    
                    return false;
                }
                
            })
            .on('pjax:start', function(e,o){
                //console.log("PJAX start");
            })
            .on('pjax:send', function() {
                //console.log("PJAX send");
            })
            .on('pjax:beforeReplace', function(html) {
                //console.log("PJAX beforeReplace");
                
            })
            .on('pjax:complete', function() {
                //console.log("PJAX complete");
                that.transitionSwitch();
                window.setTimeout(function(){
                    that.transitionEnd();
                }, pjaxTransitionSpeed);
            })
            .on('pjax:end', function(){
                //console.log("PJAX end");
                
                that.updateMetaData();
                that.updateNavHighlight();
                that.trackCurrentPageView();
                
                if(that.pageRefreshCallback) that.pageRefreshCallback();
            });
    }



//-- set custom transitions

    //start transition
    transitionStart(){
	    //console.log("PJAX:transitionStart");
        //$(this.pjaxContainer).fadeTo(this.pjaxTransitionSpeed, 0);
        
        //handle running transitions
        if($("#pjax-overlay").length){
	        $("#pjax-overlay").addClass("in");
	        return;
        }
        
        const $overlay = $('<div id="pjax-overlay"></div>');
        $("body").append($overlay);//.addClass('in');
        window.setTimeout(function(){
	        $("#pjax-overlay").addClass("in");
	        
        }, 30);

    }
    
    //middle of transition
    transitionSwitch(){
	    //console.log("PJAX:transitionSwitch");
        //$(this.pjaxContainer).fadeTo(this.pjaxTransitionSpeed, 1);
        
        $("#pjax-overlay").removeClass("in");
        
    }
    
    //on transition complete
    transitionEnd(){
	    //console.log("PJAX:transitionEnd");
        $("#pjax-overlay").remove();
        /*window.setTimeout(function(){
			//$("#pjax-overlay").remove();
        }, 500);
        */
    }
    
    //highlight navigation
    hightlightNavLevel(level, id){
        $("[data-nav-level='"+level+"'] [data-id].active").removeClass("active");
        $("[data-nav-level='"+level+"'] [data-id='"+id+"']").addClass("active");
        
    }
    
    
   
//-- update page after pageload
	
    updateMetaData(){
	    //like:  <div id='pjaxMeta' data-nav0='{$metaData['navi_id']}' data-nav1='{$metaData['subnavi_id']}' data-template='{$metaData['template_id']}'></div>";	
	    const $pjaxMeta = $("#pjaxMeta");
	    if(!$pjaxMeta.length) return;
	    
        $("body").attr("data-template", $pjaxMeta.attr("data-template"));
        $("body").attr("data-deeplink", $pjaxMeta.attr("data-deeplink"));
        $("body").attr("data-nav0", $pjaxMeta.attr("data-nav0"));
        $("body").attr("data-nav1", $pjaxMeta.attr("data-nav1"));
    }
	
	//get info from body tag and update the navigation
    updateNavHighlight(){
	    //like:  <body data-nav0='{$metaData['navi_id']}' data-nav1='{$metaData['subnavi_id']}' data-template='{$metaData['template_id']}'></body>";	
	    const $body = $("body");
	    
		this.hightlightNavLevel(0, $body.attr("data-nav0"));
		this.hightlightNavLevel(1, $body.attr("data-nav1"));
		this.hightlightNavLevel('lan', $('html').attr("lang"));
    }
    
	
	//track the current page
	trackCurrentPageView(){
		const url = location.origin + location.pathname;
		const title = document.title;
		this.trackPageView(url, title);
	}
	
	//track a custom page
	trackPageView(url, title){
		//console.log("trackPageView: "+url+" - "+title);
		if(window._paq){ 
			var _paq = window._paq;
			_paq.push(['setCustomUrl', url]);
			_paq.push(['setDocumentTitle', title]);
			//_paq.push(['setGenerationTimeMs', 0]);
			_paq.push(['enableLinkTracking']);
			_paq.push(['trackPageView']); 
		}	
		/* Update Analytics */
		//if(window.gtag){ window.gtag('config', window.GA_TRACKING_ID, {'page_path': url}); }
		
	}
	  
}

